module.exports = __webpack_public_path__ + "static/media/plus.6e5d431e.svg";